module.exports = ":host .modal-content {\n  width: 100%; }\n\n:host .negative-margin-15 {\n  margin: 0 -15px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.scss
// module id = ./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.scss
// module chunks = 0